import { isDefined, isNotDefined } from '@sgme/fp';
import type { ReactElement } from 'react';
import { FormattedNumber } from 'react-intl';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { getCurrenciesFromCurrencyPair } from '@/App/tiles/FlexiForward/utils.ts';

export function DeltaInput(): ReactElement {
  const { currencyIndex, currency1, currency2, greeksDelta } = useFlexiForwardSelector((flexiForward) => {
    const flexiForwardProperties = flexiForward.properties;

    const currencyIndex = flexiForwardProperties.notionalCurrencyIndex ?? 1;
    const { currency1, currency2 } = getCurrenciesFromCurrencyPair(flexiForward.properties.currencyPair);

    const greeks =
      flexiForwardProperties.rfs?.status === 'PRICING' || flexiForwardProperties.rfs?.status === 'EXPIRED'
        ? flexiForwardProperties?.rfs?.quote?.greeks
        : undefined;
    const greeksDelta = isNotDefined(greeks)
      ? undefined
      : Number.parseFloat(currencyIndex === 1 ? greeks.deltaCcy1 : greeks.deltaCcy2);

    return {
      currencyIndex,
      currency1,
      currency2,
      greeksDelta,
    };
  });

  return (
    <FlexiForwardFormField
      formattedMessageId="flexiForwardTile.mainFields.delta.label"
      className="align-items-baseline"
    >
      {isDefined(greeksDelta) && (
        <div className="ps-8px">
          <span className="monospace-numbers fs-12">
            <FormattedNumber value={greeksDelta} maximumFractionDigits={0} />
          </span>
          &nbsp;{currencyIndex === 1 ? currency1 : currency2}
        </div>
      )}
    </FlexiForwardFormField>
  );
}
